export default "__VITE_ASSET__b6dvUfRo__"